<template>
    <div class="not-logged-in-view">
        <div class="mask">
            <div class="content">
                <div class="text">
                    登入LINE即可<br />
                    開始解鎖道具
                </div>
                <rect-btn
                    shadow-color="rgba(171, 203, 216, 0.5)"
                    background-color="#daf0ff"
                    max-height="130px"
                    min-height="90px"
                    width="90%"
                    font-size="1.8rem"
                    @click="onLogin"
                >
                    <div class="button-content">
                        <img src="@/assets/Login/line.png" alt="" />
                        <div class="text">LINE 登入</div>
                    </div>
                </rect-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import liff from '@line/liff';

export default {
    computed: {
        ...mapState({
            liffInitFail: 'liffInitFail',
        }),
    },
    methods: {
        onLogin() {
            if (this.liffInitFail) {
                alert('無法初始化line服務，請使用訪客體驗遊玩遊戲');
            } else liff.login();
        },
    },
};
</script>

<style lang="scss" scoped>
.not-logged-in-view {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .mask {
        position: relative;
        display: flex;
        width: 100%;
        height: 100%;
        background-color: #000000af;
        overflow: auto;
        .content {
            font-size: 1.5em;
            font-weight: bold;
            padding: 20px 0;
            width: 80%;
            max-width: 400px;
            margin: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            > .text {
                color: #fff;
                margin-bottom: 20px;
            }
            .button-content {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    margin: 0 15px;
                    width: 70px;
                    height: 70px;
                    border-radius: 50%;
                }
                .text {
                    margin-right: 15px;
                }
            }
        }
    }
}
</style>
